
enum CONSTANTS{
  userHealthQrCodeParam = "userHealthQrCode",
  guildQrCodeParam = "guildQrCode",
}
export default CONSTANTS